module.exports = __webpack_public_path__ + "static/media/img-location-tainan-zh.24184cb8.svg";